export default __webpack_public_path__ + "static/media/medium.3f698244.png";